import { Link } from "react-router-dom";
import logo from "../../assets/logo.png";
import {
  FaFacebookF,
  FaInstagram,
  FaTiktok,
  FaYoutube,
  FaLinkedinIn,
} from "react-icons/fa";

const Footer = () => {
  const address =
    "Highlevel Road, Godagama, Dikhathamma, Shanthi Mawatha, No. 33 -1C - 358";
  const mapQuery = encodeURIComponent(address);

  const companyLinks = [
    { label: "About Us", path: "/about" },
    { label: "Contact Us", path: "/contact" },
    { label: "Bookings", path: "/booking" },
    { label: "Refund Policy", path: "/refund" },
    { label: "Terms & Conditions", path: "/terms" },
    { label: "Privacy Policy", path: "/privacy" },
  ];

  const exploreLinks = [
    { label: "Badminton Court", path: "/facilities/badminton" },
    { label: "Cricket Ground", path: "/facilities/cricket" },
    { label: "Table Tennis", path: "/facilities/Table Tennis" },
    { label: "Futsal", path: "/facilities/futsal" },
    { label: "Dancing Studio", path: "/facilities/dancing" },
    { label: "Archery Range", path: "/facilities/archery" },
  ];

  const socialLinks = [
    {
      icon: <FaFacebookF />,
      url: "https://www.facebook.com/VirooshSports",
      label: "Facebook",
    },
    {
      icon: <FaInstagram />,
      url: "https://www.instagram.com/viroosh_sports_complex/",
      label: "Instagram",
    },
    {
      icon: <FaTiktok />,
      url: "https://www.tiktok.com/@viroosh_ceylon",
      label: "TikTok",
    },
    {
      icon: <FaYoutube />,
      url: "https://www.youtube.com/@VirooshSportsComplex",
      label: "YouTube",
    },
    {
      icon: <FaLinkedinIn />,
      url: "https://www.linkedin.com/company/viroosh/",
      label: "LinkedIn",
    },
  ];
  return (
    <footer className="bg-black border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12">
        <div className="lg:col-span-1">
          <p className="text-white font-black uppercase tracking-widest text-xl mb-4">
            <img
              src={logo}
              alt="Viroosh Complex Logo"
              className="h-10 inline-block mr-2"
            />
          </p>
          <p className="text-white/50 text-sm leading-relaxed max-w-xs">
            To provide exceptional opportunities for those we serve to
            experience a lifetime of fitness and fun through education and
            recreation.
          </p>
          <div className="mt-8">
            <p className="text-white/25 text-[10px] uppercase tracking-[0.3em] font-bold mb-4">
              Follow Us
            </p>

            <div className="flex items-center gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-white/60 hover:text-white hover:border-red-500 hover:bg-red-500 transition-all duration-300"
                >
                  <span className="text-lg">{social.icon}</span>
                </a>
              ))}
            </div>
          </div>
        </div>

        <div>
          <p className="text-white/25 text-[10px] uppercase tracking-[0.3em] font-bold mb-5">
            Company
          </p>
          <ul className="flex flex-col gap-3">
            {companyLinks.map((link) => (
              <li key={link.label}>
                <Link
                  to={link.path}
                  className="text-white/50 hover:text-red-500 text-xs font-medium uppercase tracking-widest transition-colors duration-200"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-white/25 text-[10px] uppercase tracking-[0.3em] font-bold mb-5">
            Explore
          </p>
          <ul className="flex flex-col gap-3">
            {exploreLinks.map((link) => (
              <li key={link.label}>
                <Link
                  to={link.path}
                  className="text-white/50 hover:text-red-500 text-xs font-medium uppercase tracking-widest transition-colors duration-200"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-white/25 text-[10px] uppercase tracking-[0.3em] font-bold mb-5">
            Address
          </p>
          <p className="text-white/50 text-xs leading-relaxed mb-5">
            Highlevel Road, Godagama, Dikhathamma,
            <br />
            Shanthi Mawatha, No. 33 -1C - 358.
          </p>
          <ul className="flex flex-col gap-3 mb-5">
            <li>
              <a
                href="tel:+94770507575"
                className="text-white/50 hover:text-red-500 text-xs font-medium tracking-widest transition-colors duration-200"
              >
                +94 77 050 7575
              </a>
            </li>
            <li>
              <a
                href="mailto:bookings@viroosh.com"
                className="text-white/50 hover:text-red-500 text-xs font-medium tracking-widest transition-colors duration-200"
              >
                bookings@viroosh.com
              </a>
            </li>
          </ul>

          <a
            href={`https://www.google.com/maps/search/?api=1&query=${mapQuery}`}
            target="_blank"
            rel="noopener noreferrer"
            className="block rounded-lg overflow-hidden border border-white/10 hover:border-red-500/50 transition-colors duration-200"
          >
            <iframe
              title="Viroosh Complex Location"
              src={`https://maps.google.com/maps?q=${mapQuery}&output=embed`}
              width="100%"
              height="140"
              style={{ border: 0, filter: "grayscale(0.4) contrast(1.1)" }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="pointer-events-none"
            />
          </a>
        </div>
      </div>

      <div className="mx-6 md:mx-12 border-t border-white/10" />

      <div className="py-5 px-6 md:px-12 flex flex-col sm:flex-row items-center justify-center gap-1 text-white/25 text-[11px] tracking-widest uppercase">
        <span>
          Designed and Developed by{" "}
          <a
            href="https://tessera.lk"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-red-500"
          >
            Tessera Ops
          </a>
        </span>
        <span className="hidden sm:inline mx-2 text-white/15">|</span>
        <span className="flex items-center gap-1">
          Made with <span className="text-purple-600">Magic</span> and
          <span
            className="inline-block text-red-600"
            style={{ animation: "heartbeat 1.2s ease-in-out infinite" }}
          >
            ❤️
          </span>
        </span>
      </div>

      <style>{`
        @keyframes heartbeat {
          0%, 100% { transform: scale(1); }
          14%       { transform: scale(1.25); }
          28%       { transform: scale(1); }
          42%       { transform: scale(1.15); }
          56%       { transform: scale(1); }
        }
      `}</style>
    </footer>
  );
};

export default Footer;
